import React from 'react'
import { Card, Spinner, Scrollable, ResourceList, ResourceItem, Text } from '@shopify/polaris'
import { formatDate } from 'utils/dates'
import _ from 'lodash'

const TaxAgentClientsSection = ({ paymentInfo, fetchingPaymentInfo, t }) => {
	return (
		<Card title={t("home.title.payInfo")}>
			{fetchingPaymentInfo ? (
				<div>
					<Spinner />
				</div>
			) : (
				<Scrollable shadow className='Scrollable'>
					<br />
					{!_.isEmpty(paymentInfo) ? (
						<ResourceList
							items={paymentInfo}
							renderItem={(item, index) => (
								<ResourceItem
									key={`${index}-row`}
									id={index}
									accessibilityLabel={item.company}
								>
									<h3>
										<Text as="h6" variant="headingMd" fontWeight="bold">
											{item.company}
										</Text>
									</h3>
									<div>{t("home.subscriptionPlan")} {item.subs}</div>
									{item.next_billing_date && (
										<div>{formatDate(item.next_billing_date)}</div>
									)}
								</ResourceItem>
							)}
						/>
					) : (
						<p style={{ padding: "2rem " }}>{t("home.noClients")}</p>
					)}
				</Scrollable>
			)}
		</Card>
	)
}

export default TaxAgentClientsSection

